import { defineStore } from 'pinia'
import { computed } from 'vue';

export const useStore = defineStore('main', {
  state: () => ({
    messageItems: {},
    step: 0,
    stepData: {},
    componentData: [],
    lastactioncode: "",
    producttype:"",
    storeorderid: "",
    showMenu:true

  }),

  actions: {


    setStep(newStep) {
      this.step = newStep;
    },

    setComponentData(step, data) {
      this.componentData[step] = data;
    },
    getComponentData(step) {
      return this.componentData[step];
    },


  },

  getters: {
    // 获取步骤
    getStep() {
      return this.step
    },
  },
})

   


export const shadesDataStore = defineStore('shadesDataStore', {
    state: () => ({
        count: 10,
        stepItem: "1",
        curstep: 2,//Keep Live onMounted by dagger.li 2023-7-17
        messageItems: {},
        storeorderid: "",
        storeRoute:"",
        handSample:{  },
        tempRouter:"",
        tempcategory:"",
    }),
    getters: { //通过getters对状态state进行获取
      getMessageItems: (state) => state.messageItems,
    },
    actions: {
        changeCounter(val) {
            this.count = val
        },
        setMessageItems(data){
          this.messageItems = data;
        },
        setStep(newStep) {
        this.step = newStep;
      },

    }
})

export const useStoreleftNavOpen = defineStore('leftNavOpen', {
    state: () => ({
        openSalesInformation:false,
        openTraningResources:false,
        openMarketingResource:false,
        openReport:false,
    }),
    getters: { //通过getters对状态state进行获取
      getSalesInformation:(state) => state.openSalesInformation,
      getTraningResources:(state) => state.openTraningResources,
      getMarketingResource:(state) => state.openMarketingResource,
      getReport:(state) => state.openReport,
    },
    actions: {
        setSalesInformation(val){
          this.openSalesInformation = val || false;
        },
        setTraningResources(val){
          this.openTraningResources = val || false;
        },
        setMarketingResource(val){
          this.openMarketingResource = val || false;
        },
        setReport(val){
          this.openReport = val || false;
        }

    }
})

